import React, { FC, memo, useEffect } from 'react';
import useIntervention from 'src/hooks/api/useIntervention';
import Ticket from 'src/interfaces/api/Ticket';
import interventionsState, { InterventionState } from 'src/recoil/atoms/ticketInterventions';
import { ticketInterventionsState } from 'src/recoil/selectors/ticketInterventions';
import InterventionsTime from './InterventionsTime';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { toRecord } from 'src/utils/ArrayUtils';

interface Props {
  ticketId: Ticket['id'];
}

const InterventionsTimeContainer: FC<Props> = ({ ticketId }) => {
  const { getTicketInterventions } = useIntervention();
  const interventions = useRecoilValue(ticketInterventionsState(ticketId));
  const setInterventions = useSetRecoilState(interventionsState);

  useEffect(() => {
    getTicketInterventions(ticketId).then((collection) => {
      const hasInterventions = collection.items.length > 0;

      if (hasInterventions) {
        const newInterventions: Array<InterventionState> = collection.items.map((item) => ({ ...item, ticketId }));
        setInterventions((interventions) => toRecord(newInterventions, interventions));
      }
    });
  }, [ticketId]);

  return <InterventionsTime interventions={interventions} />;
};

export default memo(InterventionsTimeContainer);
